<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>增值税及附加税费申报表（小规模纳税人适用）附列资料（二）</dt>

      <dd>
        <div>
          纳税人名称（公章）：{{ staticConfig.companyName }}<br />
          纳税人识别号（统一社会信用代码）：<br />
          {{ staticConfig.creditCode }}
        </div>

        <div>
          税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}<br />
          填报日期：{{ staticConfig.fillFormDate }}
        </div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table>
        <thead>
          <tr>
            <td style="min-width: 120px" rowspan="3">税（费）种</td>
            <td style="min-width: 120px">计税（费）依据</td>
            <td rowspan="2">税（费）率（%）</td>
            <td rowspan="2">本期应纳税（费）额</td>
            <td colspan="2">本期减免税（费）额</td>
            <td colspan="2">增值税小规模纳税人“六税两费”减征政策</td>
            <td rowspan="2">本期已缴<br />税（费）额</td>
            <td style="min-width: 120px" rowspan="2">本期应补（退）<br />税（费）额</td>
          </tr>
          <tr>
            <td>增值税税额</td>
            <td>减免性质代码</td>
            <td>减免税（费）额</td>
            <td>减征比例（%）</td>
            <td style="min-width: 120px">减征额</td>
          </tr>
          <tr>
            <td>1</td>
            <td>2</td>
            <td>3=1×2</td>
            <td style="width: 200px">4</td>
            <td>5</td>
            <td>6</td>
            <td>7=(3-5)×6</td>
            <td>8</td>
            <td>9=3-5-7-8</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>城市维护建设税</td>
            <td>
              <!-- 自动关联主表第20行第1列 -->
              {{ parseFloatNum(data.v1x1.value) }}
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v1x2" :mode="mode">
                <template #input>
                  <el-select v-model="data.v1x2.value">
                    <el-option value="0.05" label="5.0%" />
                    <el-option value="0.07" label="7.0%" />
                  </el-select>
                </template>
                <template #score>
                  <el-select placeholder="答案" v-model="data.v1x2.answer">
                    <el-option value="0.05" label="5.0%" />
                    <el-option value="0.07" label="7.0%" />
                  </el-select>

                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              {{ parseFloatNum(data.v1x3.value) }}
            </td>
            <td>
              <el-select v-model="data.v1x4.value">
                <el-option v-for="(item, index) of options1" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>
              <taxQue :data="data.v1x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v1x6" :mode="mode">
                <template #input>
                  <el-input-number style="width: 80%; margin-right: 5px" v-model.trim="data.v1x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />%
                </template>
                <template #score>
                  <div>
                    <el-input-number
                      style="width: 80%; margin-right: 5px"
                      placeholder="答案"
                      class="score-wrap-answer"
                      v-model.trim="data.v1x6.answer"
                      :controls="false"
                      :precision="2"
                      :step="0.01"
                      :value-on-clear="null"
                    />%
                  </div>

                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x6.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              {{ parseFloatNum(data.v1x7.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v1x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v1x9.value) }}
            </td>
          </tr>
          <tr>
            <td>教育费附加</td>
            <td>
              <!-- 自动关联主表第20行第1列 -->
              {{ parseFloatNum(data.v2x1.value) }}
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v2x2" :mode="mode">
                <template #input>
                  <el-select v-model="data.v2x2.value">
                    <el-option value="0.03" label="3.0%" />
                    <el-option value="0" label="0%" />
                  </el-select>
                </template>
                <template #score>
                  <el-select placeholder="答案" v-model="data.v2x2.answer">
                    <el-option value="0.03" label="3.0%" />
                    <el-option value="0" label="0%" />
                  </el-select>

                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              {{ parseFloatNum(data.v2x3.value) }}
            </td>
            <td>
              <el-select v-model="data.v2x4.value">
                <el-option v-for="(item, index) of options2" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>
              <taxQue :data="data.v2x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v2x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v2x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v2x6" :mode="mode">
                <template #input>
                  <el-input-number style="width: 80%; margin-right: 5px" v-model.trim="data.v2x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />%
                </template>
                <template #score>
                  <div>
                    <el-input-number
                      style="width: 80%; margin-right: 5px"
                      placeholder="答案"
                      class="score-wrap-answer"
                      v-model.trim="data.v2x6.answer"
                      :controls="false"
                      :precision="2"
                      :step="0.01"
                      :value-on-clear="null"
                    />%
                  </div>

                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v2x6.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              {{ parseFloatNum(data.v2x7.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v2x9.value) }}
            </td>
          </tr>
          <tr>
            <td>地方教育附加</td>
            <td>
              <!-- 自动关联主表第20行第1列 -->
              {{ parseFloatNum(data.v3x1.value) }}
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v3x2" :mode="mode">
                <template #input>
                  <el-select v-model="data.v3x2.value">
                    <el-option value="0.02" label="2.0%" />
                    <el-option value="0" label="0%" />
                  </el-select>
                </template>
                <template #score>
                  <el-select placeholder="答案" v-model="data.v3x2.answer">
                    <el-option value="0.02" label="2.0%" />
                    <el-option value="0" label="0%" />
                  </el-select>

                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              {{ parseFloatNum(data.v3x3.value) }}
            </td>
            <td>
              <el-select v-model="data.v3x4.value">
                <el-option v-for="(item, index) of options3" :value="item.value" :label="item.label" :key="index" />
              </el-select>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v3x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              <!-- 考题 -->
              <taxQue :data="data.v3x6" :mode="mode">
                <template #input>
                  <el-input-number style="width: 80%; margin-right: 5px" v-model.trim="data.v3x6.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />%
                </template>
                <template #score>
                  <div>
                    <el-input-number
                      style="width: 80%; margin-right: 5px"
                      placeholder="答案"
                      class="score-wrap-answer"
                      v-model.trim="data.v3x6.answer"
                      :controls="false"
                      :precision="2"
                      :step="0.01"
                      :value-on-clear="null"
                    />%
                  </div>

                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x6.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td>
              {{ parseFloatNum(data.v3x7.value) }}
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x8.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              {{ parseFloatNum(data.v3x9.value) }}
            </td>
          </tr>
          <tr>
            <td>合计</td>
            <td>--</td>
            <td>--</td>
            <td>
              {{ parseFloatNum(data.v4x3.value) }}
            </td>
            <td>--</td>
            <td>
              {{ parseFloatNum(data.v4x5.value) }}
            </td>
            <td>--</td>
            <td>
              {{ parseFloatNum(data.v4x7.value) }}
            </td>
            <td>
              {{ parseFloatNum(data.v4x8.value) }}
            </td>
            <td>
              {{ parseFloatNum(data.v4x9.value) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        data.value.v1x3.value = new Big(data.value.v1x1.value).times(data.value.v1x2.value).round(2).toNumber();
        data.value.v2x3.value = new Big(data.value.v2x1.value).times(data.value.v2x2.value).round(2).toNumber();
        data.value.v3x3.value = new Big(data.value.v3x1.value).times(data.value.v3x2.value).round(2).toNumber();

        data.value.v4x3.value = new Big(data.value.v1x3.value).plus(data.value.v2x3.value).plus(data.value.v3x3.value).round(2).toNumber();
        data.value.v4x5.value = new Big(data.value.v1x5.value).plus(data.value.v2x5.value).plus(data.value.v3x5.value).round(2).toNumber();

        data.value.v1x7.value = new Big(data.value.v1x3.value).minus(data.value.v1x5.value).times(data.value.v1x6.value).times(0.01).round(2).toNumber();
        data.value.v2x7.value = new Big(data.value.v2x3.value).minus(data.value.v2x5.value).times(data.value.v2x6.value).times(0.01).round(2).toNumber();
        data.value.v3x7.value = new Big(data.value.v3x3.value).minus(data.value.v3x5.value).times(data.value.v3x6.value).times(0.01).round(2).toNumber();
        data.value.v4x7.value = new Big(data.value.v1x7.value).plus(data.value.v2x7.value).plus(data.value.v3x7.value).round(2).toNumber();

        data.value.v4x8.value = new Big(data.value.v1x8.value).plus(data.value.v2x8.value).plus(data.value.v3x8.value).round(2).toNumber();

        data.value.v1x9.value = new Big(data.value.v1x3.value).minus(data.value.v1x5.value).minus(data.value.v1x7.value).minus(data.value.v1x8.value).round(2).toNumber();
        data.value.v2x9.value = new Big(data.value.v2x3.value).minus(data.value.v2x5.value).minus(data.value.v2x7.value).minus(data.value.v2x8.value).round(2).toNumber();
        data.value.v3x9.value = new Big(data.value.v3x3.value).minus(data.value.v3x5.value).minus(data.value.v3x7.value).minus(data.value.v3x8.value).round(2).toNumber();
        data.value.v4x9.value = new Big(data.value.v1x9.value).plus(data.value.v2x9.value).plus(data.value.v3x9.value).round(2).toNumber();
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

const options1 = [
  { value: "0", label: "请选择" },
  { value: "1", label: "0007129999 | 促进就业企业限额减免城市维护建设税|其他" },
  { value: "2", label: "0007129999 | 文化单位转制为企业时的城市维护建设税优惠|其他" },
  { value: "3", label: "0007129999 | 其他|其他" },
  { value: "4", label: "0007129999 | 退役士兵从事个体经营和减城市维护建设优惠|《财政部 税务部退役军人部关于进一步扶持自主就业退役士兵创业就业有关税收政策的通知》 财税 [2019] 21号第一条" },
];

const options2 = [
  { value: "0", label: "请选择" },
  { value: "1", label: "0061129999 | 其他|其他" },
  { value: "2", label: "0061042802 | 按月纳税的月销售额或营业额不超过10万元缴纳义务人免征教育费附加| 《财政部国家税务总局关于扩大有关政府性基金免征范围的通知》 财税 [2016] 12号第一条" },
];

const options3 = [
  { value: "0", label: "请选择" },
  { value: "1", label: "0099042802 | 除小规模纳税人外月（季）销售额小于10（30）万元免征地方教育附加|《财政部国家税务总局关于扩大有关政府性基金免征范围的通知》财税 [2016] 12号第一条第（一）款" },
  { value: "2", label: "0099129999 其他|其他" },
];

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1300px !important;
}
</style>

<script>
const tableHtml = `
<table class="table1">
  <thead>
    <tr>
      <td rowspan="3" class="td-center">税（费）种</td>
      <td class="td-center">计税（费）依据</td>
      <td rowspan="2" class="td-center">税（费）率（%）</td>
      <td rowspan="2" class="td-center">本期应纳税（费）额</td>
      <td colspan="2" class="td-center">本期减免税（费）额</td>
      <td colspan="2" class="td-center">增值税小规模纳税人“六税两费”减征政策</td>
      <td rowspan="2" class="td-center">本期已缴税（费）额</td>
      <td rowspan="2" class="td-center">本期应补（退）税（费）额</td>
    </tr>
    <tr>
      <td class="td-center">增值税税额</td>
      <td class="td-center">减免性质代码</td>
      <td class="td-center">减免税（费）额</td>
      <td class="td-center">减征比例（%）</td>
      <td class="td-center">减征额</td>
    </tr>
    <tr>
      <td class="td-center">1</td>
      <td class="td-center">2</td>
      <td class="td-center">3=1×2</td>
      <td class="td-center">4</td>
      <td class="td-center">5</td>
      <td class="td-center">6</td>
      <td class="td-center">7=（3-5）×6</td>
      <td class="td-center">8</td>
      <td class="td-center">9=3-5-7-8</td>
    </tr>
  </thead>
  <tbody class="read-mode">
    <tr>
      <td class="td-center">城市维护建设税</td>
      <td>
        <div validate="data_1_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_2">
          <select validate="data_1_2">
            <option value="0.05">5.0%</option>
            <option value="0.07">7.0%</option>
          </select>
        </div>
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td>
        <div validate="data_1_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_6" class="grid-input rate-input"><input type="text" autocomplete="off" /></div>
        %
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td class="td-center">
        <div validate="data_1_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="td-center">教育费附加</td>
      <td>
        <div validate="data_2_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text alignRight">
          <select validate="data_2_2">
            <option value="0.03">3.0%</option>
            <option value="0">0%</option>
          </select>
        </div>
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td>
        <div validate="data_2_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_6" class="grid-input rate-input"><input type="text" autocomplete="off" /></div>
        %
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td class="td-center">
        <div validate="data_2_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="td-center">地方教育附加</td>
      <td>
        <div validate="data_3_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text alignRight">
          <select validate="data_3_2">
            <option value="0.02">2.0%</option>
            <option value="0">0%</option>
          </select>
        </div>
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td>
        <div validate="data_3_4" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_6" class="grid-input rate-input"><input type="text" autocomplete="off" /></div>
        %
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td class="td-center">
        <div validate="data_3_8" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
    <tr>
      <td class="td-center">合计</td>
      <td class="td-center">--</td>
      <td class="td-center">--</td>
      <td class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td class="td-center">--</td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td class="td-center">--</td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td class="td-center">
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
      <td>
        <div class="grid-text"><input type="text" autocomplete="off" readonly="readonly" /></div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number  v-model.trim="defaultValueNum" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValueNum = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
